import { NavLink } from "react-router-dom";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import { useTheme } from "@mui/material/styles";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";

import CommitmentManagerGraphicLight from "../../assets/image_first_screen_CM.png";
import CommitmentManagerGraphicDark from "../../assets/image_first_screen_CM_dark.png";
import { useCustomerContext } from "../../Context/CustomerContext";
import { useUserContext } from "../../Context/UserContext";
import useSegmentTrackEvent from "../../utils/useSegmentTrackEvent";
import { homeBullets } from "./consts";

export const Onboarding = () => {
  const theme = useTheme();
  const { customer } = useCustomerContext();
  const { userRoles } = useUserContext();
  const { trackEvent } = useSegmentTrackEvent();

  return (
    <Stack
      direction={"row"}
      sx={{
        width: { xs: "100%", md: "80%" },
        maxWidth: "1400px",
        margin: "auto",
        padding: 2,
        alignItems: "center",
      }}
    >
      <Stack
        sx={{
          width: { xs: "100%", lg: "50%" },
        }}
      >
        <Typography
          variant="h1"
          sx={{
            fontWeight: 500,
            pb: 2,
          }}
        >
          Commitment manager
        </Typography>
        <Stack maxWidth="500px">
          <Typography
            sx={{
              color: "text.secondary",
              pb: 2,
            }}
          >
            Compare your current cloud spend to your planned spend, all tracked along the baseline of your contracted
            commit spend.
          </Typography>
          <Box component="ul" sx={{ pl: 2, mb: 2 }}>
            {homeBullets.map(({ bold, text }, index) => (
              <Box
                component="li"
                key={index}
                sx={{
                  color: "text.secondary",
                  mb: 1,
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontWeight: 700,
                    mr: 1,
                    display: "inline",
                  }}
                >
                  {bold}
                </Typography>
                <Typography variant="body1" sx={{ display: "inline" }}>
                  {text}
                </Typography>
              </Box>
            ))}
          </Box>

          <Box sx={{ display: "inline-flex" }}>
            <Tooltip
              title={
                !userRoles?.cloudAnalyticsAdmin && !userRoles?.doitEmployee
                  ? "You need Cloud Analytics Admin permission to create commitments"
                  : ""
              }
              arrow
              disableHoverListener={!!userRoles?.cloudAnalyticsAdmin && !!userRoles?.doitEmployee}
              placement="right"
            >
              <span>
                <Button
                  component={NavLink}
                  variant="contained"
                  to={`/customers/${customer.id}/monitor/commitment-manager/create`}
                  sx={{ width: "fit-content" }}
                  data-cy="create-commitment-button"
                  disabled={!userRoles?.cloudAnalyticsAdmin && !userRoles?.doitEmployee}
                  onClick={() => {
                    trackEvent("Create Commitment Selected", {
                      feature: "Commitment Manager",
                      source: "Commitment Manager",
                    });
                  }}
                >
                  Create commitment
                </Button>
              </span>
            </Tooltip>
          </Box>
        </Stack>
      </Stack>

      <Box
        component="img"
        src={theme.palette.mode === "dark" ? CommitmentManagerGraphicDark : CommitmentManagerGraphicLight}
        alt="Commitment manager graphic"
        sx={{
          display: { xs: "none", lg: "block" },
          maxWidth: "50%",
          height: "auto",
          objectFit: "contain",
          alignSelf: "center",
          pl: 2,
        }}
      />
    </Stack>
  );
};
